import { INTERNAL_PROGRAM_TYPES_DEC, TrialArm } from '@tempus/trials-types';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

export const armsApi = {
  list: async (): Promise<TrialArm[]> => {
    return axios
      .get(`${TRIALS_API_ROOT}/arms`, { params: { status: true, isCustomCohort: true, overrideLimit: true } })
      .then(({ data }) => data.data);
  },
  getForTimeScreeningDropdown: async (trialId: string): Promise<{ data: TrialArm[] }> => {
    return axios
      .get(`${TRIALS_API_ROOT}/arms`, {
        params: {
          trialId,
          programType: INTERNAL_PROGRAM_TYPES_DEC.TIME,
          isCustomCohort: true,
          status: true,
          overrideLimit: true,
        },
      })
      .then(({ data }) => data);
  },
  getForSiteTrialsDropdown: async (trialId: string): Promise<TrialArm[]> => {
    return axios
      .get(`${TRIALS_API_ROOT}/arms`, {
        params: {
          trialId,
          programType: INTERNAL_PROGRAM_TYPES_DEC.ST,
          isCustomCohort: true,
          status: true,
          overrideLimit: true,
        },
      })
      .then(({ data }) => (Array.isArray(data?.data) ? data.data : []));
  },
};
